import { httpRequest } from "@services/http";
import type { LaunchListFilterOptions } from "../models/launchList";
import { legacyDashboardUrl } from "./legacyDashboardUrl";

export class CommandGetLaunchListFilters {
    async run(): Promise<LaunchListFilterOptions> {
        return await httpRequest<LaunchListFilterOptions>(legacyDashboardUrl("launch-list/filters/").toString());
    }
}
